import React from "react";

/**
 * Notification affichée quand le joueur a déjà joué aujourd'hui.
 * Règle : un seul jeu par jour et par personne, tous jeux confondus.
 */
export default function PlayLimitNotice() {
  return (
    <div
      data-testid="already-played"
      className="bg-white text-ink rounded-3xl px-5 py-4 mt-4 max-w-sm w-full text-center yum-pop"
      style={{ boxShadow: "0 8px 0 #a81a0c" }}
    >
      <div className="text-4xl mb-1">🌙</div>
      <p className="font-display font-bold text-xl leading-tight text-brand">Reviens jouer demain&nbsp;!</p>
      <p className="text-ink/70 text-sm mt-1.5">
        Un seul jeu par jour et par personne. Reviens demain pour retenter ta chance et gagner un nouveau cadeau 🎁
      </p>
    </div>
  );
}
